/** loadingSpinnerBalls din general.js. */
export function Spinner() {
  return (
    <div className="spinnerballs default">
      <div className="bounce1"></div>
      <div className="bounce2"></div>
      <div className="bounce3"></div>
    </div>
  )
}
